import { useTranslation } from 'react-i18next';

function EvaluationCard({ evaluation, currentIndex, totalQuestions, onNext, loading }) {
    const { t } = useTranslation();
    const isLastQuestion = currentIndex + 1 >= totalQuestions;

    const getScoreColor = (score) => {
        if (score >= 8) return '#10b981';
        if (score >= 6) return '#f59e0b';
        return '#ef4444';
    };

    return (
        <div className="card">
            <h3 className="eval-question">{evaluation.question}</h3>

            <div className="eval-answer-box">
                <strong>{t('interview.your_answer')}:</strong>
                <p>{evaluation.answer}</p>
            </div>

            <div className="eval-feedback">
                <p className="eval-feedback-text">{evaluation.feedback}</p>
            </div>

            <div className="eval-details">
                {evaluation.what_was_good && (
                    <div className="eval-detail good">
                        <span>✅</span>
                        <div>
                            <strong>{t('interview.what_was_good')}:</strong>
                            <p>{evaluation.what_was_good}</p>
                        </div>
                    </div>
                )}
                {evaluation.what_was_missing && (
                    <div className="eval-detail missing">
                        <span>💡</span>
                        <div>
                            <strong>{t('interview.what_was_missing')}:</strong>
                            <p>{evaluation.what_was_missing}</p>
                        </div>
                    </div>
                )}
                {evaluation.example_strong_answer && (
                    <div className="eval-detail example">
                        <span>⭐</span>
                        <div>
                            <strong>{t('interview.strong_answer_would_mention')}:</strong>
                            <p>{evaluation.example_strong_answer}</p>
                        </div>
                    </div>
                )}
            </div>

            <button
                onClick={onNext}
                disabled={loading}
                className="btn-primary"
                style={{ width: '100%', padding: '0.85rem', marginTop: '1rem' }}
            >
                {loading
                    ? t('interview.generating_report')
                    : isLastQuestion
                        ? t('interview.see_final_report')
                        : `${t('interview.next_question')} (${currentIndex + 2}/${totalQuestions}) →`}
            </button>
        </div>
    );
}

export default EvaluationCard;